export interface ConsequenceMapRegion {
  id?:         string;
  name:       string;
  assetId:    string;
  regionId:   string;
  consequenceId?: string;
  visible:    boolean;
  sections:   ConsequenceMapSection[]
}

export interface ConsequenceMapRegionDTO {
  id?: string,
  assetId: string,
  regionId: string,
  consequenceId: string
}

export function toConsequenceMapRegionDTO(data: ConsequenceMapRegion): ConsequenceMapRegionDTO {
  return {
    id: data.id,
    assetId: data.assetId,
    regionId: data.regionId,
    consequenceId: data.consequenceId
  };
}

export interface ConsequenceMapSection {
  id?:         string;
  name:       string;
  assetId:    string;
  regionId: string
  sectionId:  string;
  consequenceId?: string;
  visible:    boolean;
  elements:   ConsequenceMapElement[]
}

export interface ConsequenceMapSectionDTO {
  id?: string,
  assetId: string,
  regionId: string,
  sectionId: string,
  consequenceId: string
}

export function toConsequenceMapSectionDTO(data: ConsequenceMapSection): ConsequenceMapSectionDTO {
  return {
    id: data.id,
    assetId: data.assetId,
    regionId: data.regionId,
    sectionId: data.sectionId,
    consequenceId: data.consequenceId
  };
}

export interface ConsequenceMapElement {
  id?:         string;
  name:       string;
  assetId:    string;
  regionId: string;
  sectionId: string;
  elementId:  string;
  consequenceId?: string;
  visible:    boolean;
}

export interface ConsequenceMapElementDTO {
  id?: string,
  assetId: string,
  regionId: string,
  sectionId: string,
  elementId: string,
  consequenceId: string
}

export function toConsequenceMapElementDTO(data: ConsequenceMapElement): ConsequenceMapElementDTO {
  return {
    id: data.id,
    assetId: data.assetId,
    regionId: data.regionId,
    sectionId: data.sectionId,
    elementId: data.elementId,
    consequenceId: data.consequenceId
  };
}

export interface SectionOnlyViewItem {
  sectionId: string;
  name: string;
  assetId: string;
  instances: SectionInstance[];
  effectiveConsequenceId: string | null;
  hasMultipleConsequences: boolean;
  multiConsequenceDetails: MultiConsequenceDetail[];
  consequenceAnalysis: ConsequenceAnalysis;
}

export interface ConsequenceAnalysis {
  majorityInfo: { consequenceName: string; count: number } | null;
  differentRegions: MultiConsequenceDetail[];
}

export interface SectionInstance {
  regionId: string;
  regionName: string;
  section: ConsequenceMapSection;
}

export interface MultiConsequenceDetail {
  regionId: string;
  regionName: string;
  consequenceId: string;
  consequenceName: string;
}